import './course_player.css';
import { Link, useLocation, useParams } from "react-router-dom";
import { Header } from "../../components/header/Header";
import { useLang } from '../../context/LangContext';
import { CourseNav } from '../../components/CourseNav/CourseNav';
import { useEffect, useState } from 'react';
import { useServer } from '../../context/serverContext';
import { endpoints } from '../../env';
import { ArticleViewer } from '../../components/ArticleViewer/ArticleViewer';

export function CoursePlayer() {
    //HOOKS
    const { lang } = useLang();
    const { getRequest } = useServer();
    const {courseId, ArticleId} = useParams();
    const { state } = useLocation();

    //STATES
    const [course, setCourse] = useState(state ? state.course : null);
    const [selectedArticle, setSelectedArticle] = useState(null);
    const [lessonsActive, setLessonsActive] = useState(false);

    //FUNCTIONS
    const getArticleById = (id) => {
        for (const module of course.modules) {
            for (const article of module.articles) {
                if (article.id == id) {
                    return article;
                }
            }
        }
        return null;
    }

    //EFFECTS
    useEffect(() => {
        let data = {
            course_id: courseId,
        }

        getRequest(endpoints.getCourse, data, (res) => {
            if (res[0]) {
                res = res[1];
                setCourse(res.course);
            }
        });
    }, []);

    useEffect(() => {
        if (selectedArticle === null && course !== null) {
            setSelectedArticle(getArticleById(ArticleId));
        }
    }, [ArticleId, course]);

    return (
        <>
            <div className="course_viewer_app">
                <div className="header_container">
                    <Header />
                </div>
                <div className='course_viewer_app_body'>
                    <div className='nav'>
                        <div className='options'>
                            <div className={lessonsActive ? 'item active' : 'item'} onClick={() => setLessonsActive((prev) => !prev)}>
                                <i className="fa-solid fa-bars"></i>
                                { lang === "en" ? "Lessons" : "Lecciones"}
                            </div>
                        </div>
                        <div className='links'>
                            <Link to={course ? '/course/' + course.id : "/courses"}>
                                <i className="fa-solid fa-house"></i>
                                { lang === "en" ? "Go Back" : "Volver"}
                            </Link>
                        </div>
                    </div>
                    <div className='course_player_body'>
                        <CourseNav lessonsActive={lessonsActive} setLessonsActive={setLessonsActive} course={course} setSelectedArticle={setSelectedArticle} selectedArticle={selectedArticle} />
                        <ArticleViewer selectedArticle={selectedArticle} />
                    </div>
                </div>
            </div>
        </>
    );
}